import { useAtom } from "jotai";

import {
	$documentCollabMetadataEffect,
	$documentsListEffect,
} from "../../internal/document-list/document-list.atom";

/**
 * Hook that mounts the documents list effect.
 *
 * Call this once at app startup to subscribe to the documents list. The subscriptions run forever
 * and keep the documents list up-to-date.
 */
export const useDocsListLoader = () => {
	useAtom($documentsListEffect);
	useAtom($documentCollabMetadataEffect);
};
